/** In-memory guards only. No draft contents or credentials are stored here. */
const guards = new Set<{ check: () => boolean; restoreHash?: string }>();
let rejectedHash: string | undefined;

export function registerNavigationGuard(guard: () => boolean, restoreHash?: string): () => void {
  const entry = { check: guard, ...(restoreHash !== undefined ? { restoreHash } : {}) };
  guards.add(entry);
  return () => {
    guards.delete(entry);
  };
}

export function canNavigate(): boolean {
  rejectedHash = undefined;
  for (const guard of guards) {
    if (!guard.check()) {
      rejectedHash = guard.restoreHash;
      return false;
    }
  }
  return true;
}

export function rejectedNavigationHash(): string | undefined {
  return rejectedHash;
}
